var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-2",attrs:{"flat":""}},[_c('insurance-cart',{model:{value:(_vm.categtories),callback:function ($$v) {_vm.categtories=$$v},expression:"categtories"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }